function Layouts({ children }) {
    return (
        <div className="flex min-h-screen flex-col bg-em-bg">
            {children}
        </div>
    );
}

export default Layouts;
